import React from 'react'

const Presupuesto = () => {
  return (
    <div>Presupuesto</div>
  )
}

export default Presupuesto